import {
  CM_BASE_URL,
  AMLS_REPORT_BASE_URL
} from '../../pages/constants/cmConstants';
import { axios } from './common';
import { HISTORY_ITEMS_PER_PAGE } from '../../pages/constants/cmConstants';

export const fetchHistoryForAlert = async ({ alertId, actionType }) => {
  const params = {
    alertId,
    actionType
  };

  const url = `${CM_BASE_URL}/history`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch alert history' };
    }
    return res.data;
  });
};

export const fetchHistoryForCase = async ({ caseId, currentHistoryPage }) => {
  const params = {
    caseId,
    offset: (currentHistoryPage - 1) * HISTORY_ITEMS_PER_PAGE,
    limit: HISTORY_ITEMS_PER_PAGE
  };

  const url = `${CM_BASE_URL}/history`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch case history' };
    }
    return res.data;
  });
};

export const fetchStrReportHistoryForCase = async ({
  reportId,
  currentHistoryPage
}) => {
  const offset = (currentHistoryPage - 1) * HISTORY_ITEMS_PER_PAGE;
  const url = `${AMLS_REPORT_BASE_URL}/${reportId}/events?limit=${HISTORY_ITEMS_PER_PAGE}&offset=${offset}`;

  return axios.get(url).then((res) => {
    if (res.status !== 200) {
      throw new Error({ message: 'Failed to fetch report history' });
    }
    const body = res.data || {};
    const data = body.events || (Array.isArray(body) ? body : []);
    const totalCount = body.totalCount ?? data.length;
    return {
      events: data.map((e) => ({
        id: e.eventId,
        updatedAt: e.createdAt,
        updatedBy: e.updatedBy,
        actionDetails: e.eventName,
        timestamp: e.createdAt
      })),
      totalCount
    };
  });
};
